"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceNavigationService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var index_1 = require("../../index");
var WorkspaceNavigationService = /** @class */ (function () {
    function WorkspaceNavigationService() {
        this.navigator = index_1.instance.navigator;
    }
    WorkspaceNavigationService.prototype.goToHome = function () {
        this.navigator.go('seismic.workspace.main', {
            folderId: '',
            viewState: 'grid',
            treeExpand: 'false',
            orderBy: 'title',
        });
    };
    WorkspaceNavigationService.prototype.goToFolder = function (folderId, viewState, expand, commentid, teamsFilter) {
        this.navigator.go('seismic.workspace.main', {
            folderId: folderId,
            viewState: viewState,
            treeExpand: expand,
            commentid: commentid,
            teamsFilter: teamsFilter,
        });
    };
    WorkspaceNavigationService.prototype.goToDoc = function (params, options) {
        var routeParams = this.navigator.getRouteParams();
        var routeName = this.navigator.getRouteName();
        if (window.EmbeddedPage && window.EmbeddedPage.integratorContext && window.EmbeddedPage.config && !window.EmbeddedPage.config.openContentDetailInside) {
            window.EmbeddedPage.integratorContext.openWorkSpaceDetail(params, {
                current: { name: routeName },
                params: routeParams,
            });
            return;
        }
        this.navigator.go('seismic.workspace.doc', params, options);
    };
    WorkspaceNavigationService.prototype.goToRoot = function () {
        this.navigator.go('seismic.workspace');
    };
    WorkspaceNavigationService = __decorate([
        CommonService_decorator_1.CommonService('WorkspaceNavigationService', { replaceAngularService: 'newDoccenterNavigation' }),
        __metadata("design:paramtypes", [])
    ], WorkspaceNavigationService);
    return WorkspaceNavigationService;
}());
exports.WorkspaceNavigationService = WorkspaceNavigationService;
//# sourceMappingURL=WorkspaceNavigation.service.js.map